import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReservationsEditForm from './ReservationsEditForm';

const ReservationsEdit = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Reservation" title="Edit reservation" subParent="Reservations" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Edit reservation</H5>
                <Link to="/reservations">
                  <Btn color="primary">Back to reservations</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <ReservationsEditForm />
              </CardBody>
              <CardFooter>
                <Btn color="primary">Edit</Btn>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ReservationsEdit;
